import axios from "@/configuration/axios";
import waitFor from "@/utils/waitFor";

export default {
  strict: true,
  namespaced: true,
  state: {
    isInitialized: false,
    features: null,
  },
  getters: {
    isInitialized: state => state.isInitialized,
    features: state => state.features,
    // helpers
    hasOrganizationFeature: (state, getters, rootState, rootGetters) => feature => {
      if (!state.features) return false;
      const organization = rootGetters["organization/organization"]; // too yuck?
      if (!organization) return false;

      for (const organizationId of Object.keys(state.features)) {
        if (organizationId !== organization.id) continue;
        if (state.features[organizationId].some(r => r === feature)) return true;
      }

      return false;
    },
    hasReports: (_, getters) => getters.hasOrganizationFeature("reports"),
    hasInvestigations: (_, getters) => getters.hasOrganizationFeature("investigations"),
  },
  mutations: {
    setFeatures: (state, payload) => {
      state.features = payload;
      state.isInitialized = true;
    },
  },
  actions: {
    initialize: async context => {
      await waitFor(() => context.rootGetters["user/isInitialized"]);

      var user = context.rootGetters["user/user"];
      if (!user) {
        context.commit("setFeatures", null);
        return;
      }

      await axios
        .get(`/v1/users/${user.id}/features`)
        .then(res => context.commit("setFeatures", res.data))
        .catch(() => context.commit("setFeatures", null));
    },
  },
};
